import * as React from 'react';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';

import { HeaderButton, IHeaderButtonProps } from '../HeaderButton';

interface IFavoriteButtonProps extends IHeaderButtonProps {
  active: boolean;
}

export const FavoriteButton: React.FC<IFavoriteButtonProps> = ({ active, ...props }) => (
  <HeaderButton {...props} dataTestId="FavoriteButton">
    {active ? (
      <IconToggleHeartOn16 color="icon-negative-default" />
    ) : (
      <IconToggleHeartOff16 color="icon-secondary-default" />
    )}
  </HeaderButton>
);
